export default "__VITE_ASSET__CpJtSI2g__"